<script>
    import { createEventDispatcher } from "svelte";
    import { fade } from "svelte/transition";
    import { Button, Modal, ModalBody, ModalFooter } from "sveltestrap";
    import { deletePresetGlobal } from "./db";
    import l from "./utils/locale";
    import { _err, _log } from "./utils/logger";

    const dispatch = createEventDispatcher();
    export let allPresetGlobal = [];
    export let isShowAllPresetGlobal = false;
    //export let options = {};
    let presetInfo = null
    
    function onClickHandler(preset) {
        const p = preset.preset;
        const options = { ...p };
        dispatch("applePreset", options);
    }

    async function removeHandler(preset) {
        try {
            const result = await deletePresetGlobal(preset.id);
            if (result) {
                allPresetGlobal = allPresetGlobal.filter((v) => v.id !== preset.id);
            }
        } catch (error) {
            _err(error);
        }
    }

    function onClickClose() {
        isShowAllPresetGlobal = false;
    }

    function showInfo(preset){
        presetInfo = preset.preset
    }

    $:_log("presetInfo",presetInfo)

    const getFilterEffectName = (v) => {
        _log("getFilterEffectName",v)
        let r = ""
        try {
            const value = v.split(",")[1].trim()

       
        switch(value) {
            case "1": r = "saturated"; break;
            case "2": r = "blue"; break;
            case "3": r = "silver"; break;
            case "4": r = "neon"; break;
            case "5": r = "emboss"; break;
            case "6": r = "cartoon"; break;
            case "7": r = "blured"; break;
            case "8": r = "black"; break;
            case "9": r = "ripple"; break;
            case "10": r = "sepia"; break;
            case "11": r = "noise"; break;
            case "12": r = "vignette"; break;
            case "13": r = "gray"; break;
            default: r = ""
        }
      } catch (error) {
            _err(error)
        }
        return r
    };
</script>

<div class="allPreset allPresetGlobal" on:click|stopPropagation={() => {}}>

    {#if isShowAllPresetGlobal && allPresetGlobal.length > 0}
        {#each allPresetGlobal as preset}
            <div
                on:click={() => onClickHandler(preset)}
                class="app-file"
                transition:fade={{ duration: 200 }}
            >
                <img
                    class="app-file-img noselect"
                    src={preset.preset.cover}
                    alt=""
                />
                <!-- <div class="app-file-label-top noselect">
                    {l[preset.preset.drawMode]}
                </div> -->
                <div class="app-file-label-top noselect noselect">
                    {preset.id}
                </div>
                <div
                    class="app-file-remove"
                    on:click|stopPropagation={() => removeHandler(preset)}
                >
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        class="ionicon"
                        viewBox="0 0 512 512"
                        ><title>{l["remove"]}</title><path
                            fill="none"
                            stroke="currentColor"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="32"
                            d="M400 256H112"
                        /></svg
                    >
                </div>
                <div
                class="app-file-remove app-file-info"
                on:click|stopPropagation={() => showInfo(preset)}
            >
            <svg xmlns="http://www.w3.org/2000/svg" class="ionicon" viewBox="0 0 512 512"><title>Information</title><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="40" d="M196 220h64v172"/><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-miterlimit="10" stroke-width="40" d="M187 396h138"/><path d="M256 160a32 32 0 1132-32 32 32 0 01-32 32z"/></svg>
            </div>
            </div>
        {/each}

    {/if}
    
    <div class="closeAllPreset" on:click={onClickClose}>
        <svg
            xmlns="http://www.w3.org/2000/svg"
            class="ionicon"
            viewBox="0 0 512 512"
            ><title>{l["close"]}</title><path
                d="M289.94 256l95-95A24 24 0 00351 127l-95 95-95-95a24 24 0 00-34 34l95 95-95 95a24 24 0 1034 34l95-95 95 95a24 24 0 0034-34z"
            /></svg
        >
    </div>
</div>

<Modal isOpen={presetInfo !== null}>

	<ModalBody >
        <div class="flex preset-global-modal" on:click={()=>presetInfo=null}>
            {#if presetInfo.find}
                 <div class="flex">
                    {#if presetInfo.autocrop}
                        <div class="preset-global-modal-label">Crop:</div>
                    {:else}
                        <div  class="preset-global-modal-label">Search:</div>
                    {/if}
                    
                    <div>
                        {#each Array.from(presetInfo.find) as item}
                            {item}{". "}
                         {/each}    
                    </div>
                 </div>
            {/if}
            {#if presetInfo.filters}
                 <div class="flex">
                    <div  class="preset-global-modal-label">Filter:</div>
                    <div>
                        {#each Object.entries(presetInfo.filters) as item}
                            {item}{". "}
                        {/each}
                    </div>
                 </div>
            {/if}
            {#if presetInfo.draw}
                 <div class="flex">
                    <div  class="preset-global-modal-label">Draw:</div>
                    <div>{presetInfo.drawMode}{"."}</div>
                 </div>
            {/if}
            {#if !presetInfo.isOriginalResolution}
                 <div class="flex">
                    <div  class="preset-global-modal-label">Resize:</div>
                    <div>{presetInfo.width} x {presetInfo.ratio ? "Auto" : presetInfo.height}{"."}</div>
                 </div>
            {/if}
        </div>    
    </ModalBody>
	<ModalFooter>
		<Button
			color="primary"
			on:click={() => {
				presetInfo = null
			}}>{l["ok"]}</Button
		>
	</ModalFooter>
</Modal>
